import React, {
  forwardRef,
  InputHTMLAttributes,
  useEffect,
  useRef,
} from "react";

export interface CheckboxProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: string;
  indeterminate?: boolean;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      label,
      indeterminate = false,
      checked,
      defaultChecked,
      onChange,
      className = "",
      ...rest
    },
    ref
  ) => {
    const internalRef = useRef<HTMLInputElement>(null);
    const combinedRef =
      (ref as React.RefObject<HTMLInputElement>) || internalRef;

    useEffect(() => {
      if (combinedRef.current) {
        combinedRef.current.indeterminate = indeterminate;
      }
    }, [indeterminate, combinedRef]);

    return (
      <label
        className={`inline-flex items-center space-x-2 cursor-pointer ${className}`}
      >
        <input
          type="checkbox"
          ref={combinedRef}
          checked={checked}
          defaultChecked={defaultChecked}
          onChange={onChange}
          aria-checked={indeterminate ? "mixed" : checked}
          className="form-checkbox h-5 w-5 text-blue-600"
          {...rest}
        />
        {label && <span>{label}</span>}
      </label>
    );
  }
);

Checkbox.displayName = "Checkbox";

export default Checkbox;
